var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;stroke:#1D1D1B;stroke-width:8.0045;stroke-linecap:round;stroke-miterlimit:10.0056;}\n\t.st3{fill:none;stroke:#1D1D1B;stroke-width:15;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_00000155144627089807238850000005869279782448509594_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_92",
    transform: "matrix(0.921, -0.391, 0.391, 0.921, 2.737, 29.77)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1412",
    className: "st2",
    d: "M405.5,667.8c0,53-105.7,95.9-105.7,95.9s-105.7-42.9-105.7-95.9s105.7-95.9,105.7-95.9 S405.5,614.9,405.5,667.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1413",
    className: "st2",
    d: "M194.2,478.1c2.7,52,105.6,93.8,105.6,93.8s102.9-41.8,105.6-93.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1414",
    className: "st2",
    d: "M194.2,857.5c2.7-52,105.6-93.8,105.6-93.8s102.9,41.8,105.6,93.8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_87",
    transform: "translate(10.758 15.343)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_13",
    className: "st2",
    x1: 216.2,
    y1: 509.7,
    x2: 275,
    y2: 509.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_14",
    className: "st2",
    x1: 303.2,
    y1: 509.7,
    x2: 361.9,
    y2: 509.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    transform: "translate(10.758 108.773)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_15",
    className: "st2",
    x1: 214.4,
    y1: 701.1,
    x2: 273.1,
    y2: 701.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_16",
    className: "st2",
    x1: 303.2,
    y1: 701.9,
    x2: 361.9,
    y2: 701.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    transform: "translate(10.758 45.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_17",
    className: "st2",
    x1: 216.2,
    y1: 571.2,
    x2: 275,
    y2: 571.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_18",
    className: "st2",
    x1: 303.2,
    y1: 571.2,
    x2: 361.9,
    y2: 571.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_90",
    transform: "translate(10.758 76.754)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_19",
    className: "st2",
    x1: 212.6,
    y1: 634.4,
    x2: 271.3,
    y2: 634.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_20",
    className: "st2",
    x1: 306.8,
    y1: 637.6,
    x2: 365.6,
    y2: 637.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_91",
    transform: "translate(0 61.002)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_21",
    className: "st2",
    x1: 194.1,
    y1: 603.6,
    x2: 279.4,
    y2: 603.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_22",
    className: "st2",
    x1: 320.3,
    y1: 603.6,
    x2: 405.5,
    y2: 603.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000110435128547692348900000013268085022241044655_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    transform: "translate(-441.827 125.909)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    transform: "translate(441.827 -83.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1415",
    d: "M544.9,675.5c-3-2.1-4.6-5.7-4.1-9.3c0.3-14.8-0.2-29.7,0.6-44.5c0.5-11.2,1.8-22.3,3.9-33.4 c3.6-18.7,16.8-30,32.1-39.3c10.7-6.5,22.3-11.9,32.3-19.4c12-9.1,22.6-20,33.9-30c3-2.8,6.2-5.4,9.6-7.7 c7.7-4.9,15.8-6.1,24.1-0.3c1.3-3.1,2.7-6,3.9-8.9c3.9-9.3,7.8-18.6,11.7-27.9c3.8-8.2,12.3-13.4,21.3-12.9 c9.2,1.3,15.9,9.4,15.6,18.7c0.1,7.3-0.7,14.6-2.4,21.8c-4.6,18-10.2,35.6-14.9,53.6c-3.9,14.5-11.5,27.8-22.1,38.5 c-16,16.8-32.6,33.1-49,49.5c-1.9,1.9-3.5,3.3-1.8,6.2c0.4,1.2,0.5,2.5,0.2,3.7c0,10.9-0.1,21.7,0.1,32.6 c0.4,3.7-1.3,7.2-4.4,9.2L544.9,675.5z M553.2,623.9l1.2,0.4c0.2,0.1,0.5,0.2,0.7,0.2c21.8,0,43.7,0,65.5,0 c1.1,0,2.1-0.5,2.9-1.2c18.9-18.8,38-37.6,56.6-56.7c9.4-9.4,16.3-21,19.8-33.8c5-18.4,10.5-36.6,15.3-55 c1.2-5.3,1.8-10.8,1.8-16.2c0.1-2.8-0.7-6.5-4.4-6.9c-3.3-0.2-6.5,1.7-7.9,4.8c-0.4,0.8-0.8,1.6-1,2.4 c-7.3,17.3-14.4,34.7-21.9,52c-1.5,3.5-3.6,6.8-6.1,9.8c-11.9,13.5-24,26.8-36,40.1c-2.8,3.5-5.9,6.8-9.2,9.8 c-1.9,1.4-4.4,1.8-6.7,1.2c-2-1.3-3.4-3.3-3.8-5.7c0.1-2,0.9-3.8,2.3-5.2c14.4-16.2,29-32.3,43.4-48.6c2.1-2.4,3.6-5.3,4.3-8.4 c1.1-4.7-1.9-7.4-6.5-5.9c-3,1.1-5.8,2.8-8.2,4.9c-4.3,3.6-8.2,7.7-12.2,11.5c-17.4,16.4-35.8,31.3-57.5,41.8 c-7.4,4.1-14,9.4-19.8,15.7c-3.5,3.5-6,8-7.2,12.8C556.3,599.7,555,611.9,553.2,623.9z M554,662.4h72.6v-24.7H554L554,662.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1416",
    d: "M346.4,459.7c0.8-2.3,1.4-4.8,2.3-7c3.1-8.7,12.7-13.2,21.4-10.1c0.6,0.2,1.1,0.4,1.7,0.7 c5.8,2.3,10.3,6.8,12.6,12.6c4.3,10.8,8.9,21.4,13.4,32c0.5,1.1,1,2.2,1.5,3.3c12-5.6,20.7-3.9,31.3,5.9 c9.3,8.6,18.8,17.2,28.1,25.9c10.7,10,23.5,16.7,36.1,23.8c7.3,4.2,14.3,9.1,20.7,14.6c10.7,8.9,15.4,21,17.5,34.5 c3.6,24.1,2.8,48.3,2.9,72.5c-0.1,3-1.8,5.8-4.4,7.2h-90.7c-2.9-2-4.4-5.5-4-9c0.2-8,0.1-16,0.1-23.9c-0.4-4.1-0.3-8.2,0.3-12.3 c0.8-2.6-0.2-5.4-2.5-6.9c-15.6-15.6-31.3-31.1-46.7-46.9c-12.5-12.8-21.3-28.8-25.4-46.2c-4.8-20.2-10.8-40.1-16.3-60.1 L346.4,459.7z M523.2,624.6c-1.2-10.3-2.4-20.1-3.6-29.8c-1-9.9-6.1-19-14-25.2c-5.5-4.3-11.2-8.2-17.1-11.9 c-10.2-6.4-21.3-11.8-30.7-19.1c-12.2-9.5-23.1-20.5-34.6-30.9c-3.4-3.1-6.7-6.5-11.6-7c-3.5-0.4-5.1,1.1-5.3,4.6 c0.1,4,1.9,7.8,4.9,10.5c14.4,16,28.7,31.9,43,47.9c1,1.1,1.8,2.4,2.2,3.8c0.9,2.9-0.5,6-3.3,7.2c-3.5,1.7-6.2,0.2-8.6-2.5 c-14.7-16.5-29.6-32.8-44.2-49.4c-2.2-2.5-4-5.4-5.3-8.5c-3.9-8.6-7.4-17.4-11.1-26.1c-4-9.4-7.9-18.8-11.9-28.2 c-1.4-3.2-5.6-6.1-8.2-5.5c-3.5,0.8-4.2,3.9-4.3,6.7c-0.3,4.1-0.1,8.2,0.7,12.2c4.5,17.2,10,34.2,14.2,51.5 c3.4,15.8,11.1,30.4,22.3,42c18.6,18.9,37.5,37.6,56.4,56.3c1.2,0.8,2.6,1.3,4,1.2c15.2,0.1,30.5,0,45.7,0L523.2,624.6z  M522.9,662.5c0-7.1-0.2-14.1,0.1-21c0.1-3.2-0.9-4-4-4c-21.1,0.1-42.1,0.1-63.2,0.1c-1.9,0-3.9,0.2-5.7,0.3v24.7L522.9,662.5 L522.9,662.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_94",
    transform: "translate(471.549 -125.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1418",
    d: "M499.3,568.8c-1.5-0.4-2.9-1-4.3-1.7c-2.3-1.3-2.5-2.8-1-4.9c0.6-0.8,1.1-1.5,1.8-2.5l-2.5-1.2 c0-3.8,2.6-7.1,6.2-8.1c3-0.7,6.2-0.9,9.3-1.4c0.9-0.2,1.8-0.6,2.5-1.2c3.5-2.8,7.2-5.3,11-7.6c2.7-1.2,4.4-3.9,4.4-6.9 c0.1-2.8-0.4-5.5-1.5-8c-3.3-7.5-7.2-14.8-10.6-22.3c-0.6-1.8-0.9-3.8-0.9-5.7c-0.6-6-0.6-6-6.2-4.7c-9.6,2-19.6,0.7-28.4-3.9 c-7.8-3.9-14.9-9-21.1-15c-1.8,1.8-3.4,3.6-5.2,5.2c-0.5,0.6-1.3,0.9-2.1,0.9c-4.2-0.8-8.4-1.9-12.6-3.2c-2-1.1-3.9-2.4-5.5-4 c-3.7,3.4-5.8,8.2-5.6,13.2c0,3.9,0.5,7.8,0.9,11.9c0.2,0.1,0.7,0.3,1.3,0.5c2.6,1.1,4.6,2.7,4.4,6c-0.2,2.7,0.1,5.4-0.2,8 c-0.4,2.9-2.5,3.7-4.6,1.7c-1.6-1.7-2.8-3.6-3.8-5.7c-1-2.1-1.4-4.4-2.3-6.5c-0.4-1-1.1-2-1.9-2.7c-2.9-2-3.9-5.8-2.3-8.9 c1.3-3.7,2.2-7.5,3.2-11.4c0.8-3,1.4-6.1,2-9.2c-2.1-0.4-4.2,0.2-5.8,1.6c-3.4,3-5.7,7.1-6.3,11.6c-0.8,3.5-1,7.1-1.5,10.6 c-0.2,1,0.4,2.1,1.4,2.5c1,0.5,1.7,1.3,2.1,2.3c0.6,1.8,1.1,3.6,1.4,5.4c0.6,3.2-0.6,6.6-3.1,8.7c-2.3,2.2-4.1,1.9-5.3-1.1 c-0.5-1.2-0.8-2.4-1-3.7c-0.5-5.4-1.6-10.8-3.2-16c-1.2-3.9-0.5-8.2,1.9-11.5c3-4.4,4.9-9.3,5.7-14.5c0.8-4.2,2.6-6.3,6.6-6.8 c2.8-0.4,5.7-0.3,8.5,0.1c6.4,1.2,13,1.3,19.4,0.3c0-2.5-0.1-5,0-7.6c0.5-5,1.9-9.9,4.1-14.4c2.2-4.8,4.6-9.6,6.6-14.5 c2.1-5.3,2.4-11.1,0.7-16.5c-0.5-2.4-2.1-4.5-4.4-5.5c-2.5,2.3-4.9,4.4-7.2,6.4c-2.1,2.3-5.2,3.6-8.3,3.4 c-0.4,1.1-0.8,2.2-1.2,3.3c-1.3,2.9-4.4,4.4-7.5,3.7c-3.1-0.5-5.5-3-5.9-6.2c-0.3-3.1,0.4-6.2,2.1-8.8c1.4-2.2,2.6-4.5,3.6-6.9 c1.6-3.9,2.9-8,4.6-11.9c1.2-2.3,2.6-4.5,4-6.7c0.4-0.7,0.6-1.5,0.7-2.2c0.1-3.5,0-7,0-11.2l4,3.4c-0.2-1.3-0.2-2.6-0.2-3.9 c0.1-1.8,1.2-2.4,2.5-1.1c2.1,2.2,4.2,4.5,6.1,6.9c0.5,0.9,1.6,1.3,2.6,1.1c11.6-2.2,23.6,0.8,32.7,8.4c0.5,0.4,0.9,0.8,1.4,1.2 c0.1,0.1,0.1,0.3,0.1,0.4h-5.2l-0.2,0.5c0.9,0.8,1.8,1.7,2.7,2.4c5.7,3.8,10.6,8.6,14.7,14.1c1.4,2,2.5,4.2,4.1,6.9l-6.8-2.5 l-0.4,0.4c0.6,1,1.2,2.1,1.9,3.1c4.5,6.2,7.4,13.5,8.3,21.1c0.2,2.6,0.2,5.2,0,7.8c-0.2,1,0.3,2.1,1.2,2.5 c3.8,2.3,8.1,3.6,12.5,3.8c7.7,0.2,15.4,1.4,22.8,3.5c7,1.9,13.2,5.9,18,11.3c0.3,0.4,0.8,0.7,1.2,1c12,5.7,20.9,14.9,29,25.1 c2.3,2.9,4,6.2,6.5,8.9c2.1,2.5,4.6,4.6,7.4,6.4c7.9,4.4,16.5,7.5,25.4,9.1c1,0.2,2,0.6,2.9,1.1c-3.2,1-6.4,2.2-9.7,2.9 c-8.4,2.2-17,2.8-25.6,1.8c-10.2-0.7-18.5-8.8-19.3-19c-0.8-5.1-1.2-10.3-1.8-15.4c-0.2-1.6-0.7-3.2-1.4-4.7 c-1.2-2.5-4.1-3.6-6.7-2.6c-0.5,0.3-0.9,0.9-0.9,1.5c0.2,15.5-7.8,26.3-19.8,34.7c-2.3,1.5-3.8,4-4.1,6.8 c-0.7,5.4,0.2,10.8,2.5,15.8c2.2,4.8,0.2,10.4-4.6,12.6c-1.2,0.6-2.5,0.9-3.8,0.9c-0.7,0-1.5,0.2-2.1,0.5 c-6.8,3.3-12.5,8.5-16.3,15c-0.5,0.8-1.2,1.4-2.1,1.6c-4.9,0.5-9.1,3.9-10.5,8.6c-0.1,0.3-0.2,0.5-0.3,0.8L499.3,568.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    transform: "translate(-142.147 302.697)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1419",
    d: "M880.5,240.6c-17.1,26.3-39.1,48.9-64.9,66.7c-29.4,20.7-63.5,34-99.2,38.5 c-40.1,5.2-80.9-0.2-118.3-15.7c-44.8-18.2-81.4-47.2-111.6-84.7c-4-4.6-4.1-11.4-0.2-16.1c34.4-41.7,75.2-74.7,127.3-91.6 c49.3-16,98.1-13.3,146.1,5.7c37,14.7,68.8,37.3,97.4,64.6c6.4,6.1,12.6,12.6,18.7,19.1c1.7,2.1,3.3,4.2,4.7,6.5L880.5,240.6z  M852,238.6c-8.1-7.7-15-14.7-22.4-21.1c-8.3-7.2-16.8-14.1-25.7-20.5c-31.7-23-66.6-38.6-105.9-43c-26.6-3-53.6,0.1-78.9,8.8 c-31.5,11.1-60.2,28.9-84.2,52.1c-7.6,7.1-14.7,14.7-21.9,22.1c36.9,43.8,91.1,77.1,150.8,83.8c23,2.7,46.2,1.4,68.8-3.8 c33.8-7.9,65-24.5,90.5-48.2C833.1,259.4,842.1,248.9,852,238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1420",
    d: "M682.1,171.9c36.2,0.2,65.4,29.5,65.7,65.6c-0.2,36.1-29.4,65.4-65.5,65.8 c-36.3-0.2-65.7-29.5-65.8-65.8C616.7,201.3,646,172.1,682.1,171.9z M665.4,237.7c13.8,0.3,25.2-10.6,25.5-24.4 c0-0.2,0-0.4,0-0.6c0.2-14-11-25.5-25-25.7c-14.1,0-25.6,11.4-25.7,25.5C640.4,226.4,651.6,237.6,665.4,237.7L665.4,237.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    transform: "translate(-41.259 -252.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1421",
    d: "M490.4,639.2c5.9,1.8,11.9,3.2,17.5,5.5c4,1.8,7.7,4.2,11,7c6.9,5.7,9.2,13.2,5.7,21.4 c-3.3,7.5-7.2,14.8-11.5,21.8c-6.6,11-13.3,21.9-17.1,34.3c-6.5,21.8-9.1,44.5-7.7,67.2c0.5,12.9,2.9,25.7,7.2,37.9 c7,19.7,21.3,35.9,40.1,45.1c33.2,16.7,66.2,15.4,97.7-4.4c20.1-12.5,31.8-31.3,36.6-54.4c3.7-18.2,4.5-36.8,2.6-55.2 c-1.6-16-4.3-31.8-11.1-46.5c-4.3-9.4-10-18.1-15-27.1c-2.9-5.1-6-10.1-8.4-15.4c-5.2-11.2-2.7-20,7.3-27.1 c7-5.1,15.2-8.4,23.8-9.7c0.7-0.1,1.3-0.3,2-0.6h10.2c8.9,2.2,16,8.8,19,17.4c3.5,8.2,5.1,17,4.8,25.9c0,2.9-0.9,5.7-2.5,8 c-3,3.4-3.4,8.3-1,12.2c0.7,1.4,1.4,2.8,2.1,4.3c12.4,24.1,20,50.4,22.3,77.4c2.4,25.3-1.1,50.8-10.2,74.5 c-10.8,29.2-31.9,53.4-59.2,68.2c-19.3,10.4-40.7,16.5-62.6,17.9c-23.4,2.1-47-0.9-69-9c-52.4-19.6-80-58.8-88.3-113 c-0.9-6-1.3-12.1-1.9-18.1v-11.4c0.2-1.4,0.5-2.7,0.5-4.1c1.1-21.9,5.9-43.4,14.1-63.7c3.2-7.9,7-15.6,10.6-23.3 c2.2-3.7,1.8-8.3-1-11.6c-1.7-2.4-2.6-5.3-2.6-8.3c0-5.5,0.6-10.9,1.8-16.2c2.9-12.5,8-23.5,21.9-27.1H490.4z M461.6,811 c5,0,9-4,9-9s-4-9-9-9c-0.1,0-0.2,0-0.3,0c-4.9,0.1-8.8,4.2-8.7,9.1c-0.1,4.8,3.7,8.9,8.5,9C461.3,811,461.5,811,461.6,811z  M708.8,801.8c0-4.9-4-8.9-8.9-8.9c-5,0-9,4-9,9c0,5,4,9,9,9c0,0,0,0,0,0c4.8,0.1,8.8-3.8,8.9-8.6 C708.8,802.2,708.8,802,708.8,801.8L708.8,801.8z M479.8,737.1c0.2-5-3.7-9.1-8.7-9.2c-0.1,0-0.3,0-0.5,0 c-4.9,0.2-8.7,4.2-8.9,9.1c0,5,4.1,9,9,9c0,0,0.1,0,0.1,0c4.8,0.1,8.8-3.7,8.9-8.5C479.8,737.2,479.8,737.2,479.8,737.1 L479.8,737.1z M690.6,745.9c5,0,9-4,9-9c0,0,0,0,0-0.1c-0.2-4.9-4.2-8.8-9-8.9c-5,0-9,4-9,8.9c0,0.2,0,0.3,0,0.5 c0,4.8,3.9,8.7,8.7,8.7C690.4,745.9,690.5,745.9,690.6,745.9L690.6,745.9z M589.7,915.1c0-5-4-9-9-9c-5,0-9,4-9,9 c0,0.1,0,0.2,0,0.3c0.2,5,4.3,8.9,9.3,8.7C585.8,923.9,589.7,920,589.7,915.1z M487.5,867.1c0.1-4.8-3.6-8.8-8.4-9 c-0.2,0-0.4,0-0.5,0c-4.9,0-8.9,3.9-9,8.8c0,5,4,9.1,9,9.2c4.9,0.1,8.9-3.8,9-8.8C487.5,867.3,487.5,867.2,487.5,867.1 L487.5,867.1L487.5,867.1z M673.8,866.8c-0.2,4.9,3.6,9.1,8.5,9.3c0.1,0,0.2,0,0.3,0c5,0,9.1-4,9.2-9c-0.1-4.9-3.9-8.9-8.8-9 c-4.8-0.3-8.9,3.4-9.2,8.2C673.8,866.5,673.8,866.7,673.8,866.8L673.8,866.8z M497.6,678.3c0.1-4.5-3.4-8.2-7.9-8.4 c-4.5,0-8.2,3.5-8.4,8c-0.1,4.5,3.4,8.2,7.9,8.4c4.5,0.1,8.2-3.4,8.3-7.8C497.6,678.4,497.6,678.3,497.6,678.3L497.6,678.3z  M680,678c-0.1-4.5-3.7-8.1-8.2-8.2c-4.5,0.1-8.1,3.8-8.1,8.2c0,4.5,3.6,8.1,8,8.1c0,0,0.1,0,0.1,0 C676.4,686.2,680,682.5,680,678L680,678z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    transform: "translate(2.533 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_10",
    className: "st3",
    cx: 544.7,
    cy: 471.8,
    r: 107
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_865",
    className: "st3",
    d: "M544.7,316.6c-85.7,0-155.2,69.5-155.2,155.2c0,22.6,4.9,45,14.5,65.6 c23,49.4,70.3,83.1,124.4,88.8c5.4,0.6,10.9,0.9,16.3,0.9c7.9,0,15.7-0.6,23.5-1.8c54-8.3,99.7-44.4,120.3-95 c7.6-18.6,11.4-38.4,11.4-58.5C699.9,386.1,630.5,316.6,544.7,316.6z M544.7,364.8c59.1,0,107,47.9,107,107s-47.9,107-107,107 c-59.1,0-107-47.9-107-107C437.7,412.7,485.6,364.8,544.7,364.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    className: "st3",
    cx: 544.7,
    cy: 471.8,
    r: 107
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_866",
    className: "st3",
    d: "M801.3,706.8l-85.8,3.3c-0.7,0-1.3,0.4-1.6,1.1l-35.5,76.5c-0.4,0.9-1.5,1.3-2.4,0.9 c-0.3-0.1-0.6-0.4-0.8-0.7L569.8,627.7c-0.6-0.8-0.3-2,0.5-2.5c0.2-0.1,0.5-0.2,0.7-0.3c51.7-8.9,95.4-43.2,116.2-91.3 c0.4-0.9,1.5-1.4,2.4-1c0.3,0.1,0.6,0.4,0.8,0.7L802.7,704c0.6,0.9,0.3,2-0.5,2.5C801.9,706.7,801.6,706.8,801.3,706.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_867",
    className: "st3",
    d: "M526.8,628.7L420.4,790.5c-0.6,0.8-1.7,1.1-2.6,0.5c-0.3-0.2-0.5-0.5-0.7-0.8l-35.5-76.5 c-0.3-0.6-0.9-1-1.6-1.1l-85.8-3.3c-1,0-1.8-0.9-1.8-1.9c0-0.3,0.1-0.7,0.3-0.9l109.5-166.5c0.6-0.8,1.7-1.1,2.5-0.5 c0.3,0.2,0.5,0.4,0.6,0.7c23.1,46.9,68.2,79,120.1,85.5c1,0.1,1.7,1,1.6,2C527.1,628.2,527,628.4,526.8,628.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.22a4b0f59b29c760f98cfc29e8828aea.svg";
export { ForwardRef as ReactComponent };